import { useEffect } from "react"

import { WebApp } from "@/shared/telegram"

import { CloneLaunchScreen } from "./clone-launch-screen"

interface CloneAuthErrorScreenProps {
  botHandle: string
}

export const CloneAuthErrorScreen: React.FC<CloneAuthErrorScreenProps> = ({ botHandle }) => {
  useEffect(() => {
    WebApp.disableClosingConfirmation()
  }, [])

  const handleClose = () => {
    WebApp.close()
  }

  return (
    <CloneLaunchScreen
      variant="error"
      botHandle={botHandle}
      onAction={handleClose}
    />
  )
}
